var React = require('react');

function FaqArrow2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.24407 0.872872C4.64284 0.41241 5.35716 0.41241 5.75593 0.872872L8.76318 4.34535C9.32406 4.99299 8.864 6 8.00725 6L1.99275 6C1.136 6 0.675944 4.99299 1.23682 4.34535L4.24407 0.872872Z","fill":"#3048a1"}));
}

FaqArrow2.defaultProps = {"width":"10","height":"6","viewBox":"0 0 10 6","fill":"none"};

module.exports = FaqArrow2;

FaqArrow2.default = FaqArrow2;
